import { BACKGROUND_SET } from "./types";

export const setBackground = (background) => ({
  type: BACKGROUND_SET,
  payload: background,
});
